import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

let _cache = null;

export default function useCaPrice() {
  const [data, setData] = useState(_cache);
  const [loading, setLoading] = useState(!_cache);

  const refresh = useCallback(async (force = false) => {
    setLoading(true);
    try {
      const res = await api.get(`/ca-price${force ? "?force=true" : ""}`);
      _cache = res.data;
      setData(res.data);
    } catch {
      /* keep last known */
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { if (!_cache) refresh(); }, [refresh]);

  return {
    price: data?.price ?? null,
    botPrice: data?.bot_price ?? null,
    change24h: data?.change_24h ?? null,
    isLive: data?.is_live ?? false,
    updatedAt: data?.updated_at ?? null,
    source: data?.source ?? "",
    loading,
    refresh,
  };
}
